import React from 'react';
import ThemeProvider from '../theme';
import './DiamondApp.scss';
const DiamondApp = ({ children }) => {
    return (React.createElement(ThemeProvider, null,
        React.createElement("div", null, children)));
};
export default DiamondApp;
